import { render, staticRenderFns } from "./SignScreenShow_ad.vue?vue&type=template&id=d15f6052&scoped=true&"
import script from "./SignScreenShow_ad.vue?vue&type=script&lang=js&"
export * from "./SignScreenShow_ad.vue?vue&type=script&lang=js&"
import style0 from "./SignScreenShow_ad.vue?vue&type=style&index=0&id=d15f6052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15f6052",
  null
  
)

export default component.exports